import {
    GET_PURCHASE_PAID_BILL_REPORT_REQUEST,
    GET_PURCHASE_PAID_BILL_REPORT_SUCCESS,
    GET_PURCHASE_PAID_BILL_REPORT_FAILURE,
    SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST,
    SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_BILLS,
    SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST,
    SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BILLS,
    SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST,
    RESET_PURCHASE_PAID_REPORT
} from '../types/purchase-paid-bill-report-types';

const initialState = {
    purchasePaidBillReport: {},
    purchasePaidBillPartywiseBills: {},
    purchasePaidBillPartywiseParties: {},
    purchasePaidBillBrokerwiseBills: {},
    purchasePaidBillBrokerwiseParties: {},
    purchasePaidBillBrokerwiseBrokers: {},
    loading: false,
    data: null,
    error: null
};

const purchasePaidBillReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PURCHASE_PAID_BILL_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_PURCHASE_PAID_BILL_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST:
            return {
                ...state,
                loading: false,
                purchasePaidBillPartywiseParties: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case SET_PURCHASE_PAID_BILL_PARTYWISE_REPORT_BILLS:
            return {
                ...state,
                loading: false,
                purchasePaidBillPartywiseBills: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST:
            return {
                ...state,
                loading: false,
                purchasePaidBillBrokerwiseParties: {...(action.payload || {})},
                data: action.payload,
                error: null
            };
    
        case SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BILLS:
            return {
                ...state,
                loading: false,
                purchasePaidBillBrokerwiseBills: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case SET_PURCHASE_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST:
            return {
                ...state,
                loading: false,
                purchasePaidBillBrokerwiseBrokers: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case GET_PURCHASE_PAID_BILL_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case RESET_PURCHASE_PAID_REPORT:
            return {
                ...state,
                purchasePaidBillReport: {},
                purchasePaidBillPartywiseBills: {},
                purchasePaidBillPartywiseParties: {},
                purchasePaidBillBrokerwiseBills: {},
                purchasePaidBillBrokerwiseParties: {},
                purchasePaidBillBrokerwiseBrokers: {},
                loading: false,
                data: null,
                error: null
            };

        default:
            return state;
    }
};

export default purchasePaidBillReportReducer;
